import { render, staticRenderFns } from "./AdminResvMenu.vue?vue&type=template&id=f1fa0f70&scoped=true&"
import script from "./AdminResvMenu.vue?vue&type=script&lang=js&"
export * from "./AdminResvMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminResvMenu.vue?vue&type=style&index=0&id=f1fa0f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fa0f70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
